import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import type { Args } from 'webapp/components/templates/recommended-base';
import TemplatesPublicRecommendedBaseComponent from 'webapp/components/templates/recommended-base';

import type Template from 'webapp/models-custom/template';
import type ReportRecord from 'webapp/models/report';

export default class TemplatesPublicRecommendedReportsComponent<
	T extends Args,
> extends TemplatesPublicRecommendedBaseComponent<T> {
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;

	redirectRoute = 'reports.public-templates.index';
	defaultOrigin = 'recommended_report_templates';

	get model(): Template[] {
		return this.mmTemplatesService.getRecommendedReportPublicTemplateModels(this.maxItemsShown);
	}

	requestTemplates() {
		return this.mmTemplatesService.requestReportPublicTemplates();
	}

	onTemplateUse(model: Template): void {
		const afterUse = (reportRecord: ReportRecord) => {
			const afterTransition = () => {
				const reportModel = this.mmReportsService.createModel(reportRecord);
				this.mmReportsService.openPreviewPopup(reportModel);
			};

			this.navigationService.transitionToRoute('reports.index').then(afterTransition);
		};

		this.mmTemplatesService.trackEvent(model, TrackingEvent.USE_A_TEMPLATE);
		this.mmReportsService.createReportFromTemplate(model, this.origin, afterUse);
	}
}
